import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';

interface ContributionsProjetState {
  editId: string | null;
  showFormEmploye: boolean;
  showFormProjet: boolean;

  setEditId: (id: string | null) => void;
  setShowFormEmploye: (v: boolean) => void;
  setShowFormProjet: (v: boolean) => void;
  reset: () => void;
}

export const useContributionsProjetStore = create<ContributionsProjetState>()(
  persist(
    (set) => ({
      editId: null,
      showFormEmploye: false,
      showFormProjet: false,

      setEditId: (id) => set({ editId: id }),
      setShowFormEmploye: (v) => set({ showFormEmploye: v }),
      setShowFormProjet: (v) => set({ showFormProjet: v }),
      reset: () => set({ editId: null, showFormEmploye: false, showFormProjet: false }),
    }),
    {
      name: 'contributions-projet-storage',
      storage: createJSONStorage(() => localStorage),
      partialize: () => ({}),
    },
  ),
);
